import React, { useRef } from 'react';
import classNames from 'classnames';

export default function TabsHeader({ tabs, currentTab, setCurrentTab }) {
  const tabRefs = useRef({});

  const onKeyDown = (event) => {
    const setIndex = (index) => {
      setCurrentTab(index);
      const tab = tabRefs.current[index];
      if (tab) {
        tab.focus();
      }
    };

    const count = tabs.length;
    const nextTab = () => setIndex((currentTab + 1) % count);
    const prevTab = () => setIndex((currentTab - 1 + count) % count);
    const firstTab = () => setIndex(0);
    const lastTab = () => setIndex(count - 1);

    const keyMap = {
      ArrowRight: nextTab,
      ArrowLeft: prevTab,
      Home: firstTab,
      End: lastTab,
    };

    const action = keyMap[event.key];

    if (action) {
      event.preventDefault();
      action();
    }
  };

  return (
    <div
      className="bmc-page-tabs-header"
      role="tablist"
      aria-orientation="horizontal"
    >
      {tabs.map((tab, index) => (
        <div
          key={index}
          role="tab"
          className={classNames('bmc-page-tabs-header-tab', {
            'bmc-page-tabs-header-tab--active': currentTab === index,
          })}
          ref={(element) => (tabRefs.current[index] = element)}
          aria-selected={currentTab === index}
          onClick={() => setCurrentTab(index)}
          onFocus={() => setCurrentTab(index)}
          onKeyDown={onKeyDown}
          tabIndex={currentTab === index ? 0 : -1}
        >
          {tab}
        </div>
      ))}
    </div>
  );
}
